import api from './AxiosInstance';

export class TableauOrdreService {
  
  getAllTableauOrdre = async () => {
    try {
      const response = await api.get(`/Fournisseur/Ordre/list`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };


  addAgree= async ( payload) => {
    try {
      const response = await api.post(`/Fournisseur/Ordre/Agreer`, payload )
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  updateTableauOrdre= async ( updatedPrestation) => {
    try {
     

      const response = await api.put(`/Benef/typeBenef/update`, updatedPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  deleteTableauOrdre= async ( prestationId) => {
    try {
    
      const response = await api.delete(`/Benef/typeBenef/delete/${prestationId}`) 

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };
  //
}


